import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/back-button";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto pt-16">
        <div className="fixed top-4 left-4 z-50">
          <BackButton onClick={() => navigate(-1)} />
        </div>

        <h1 className="text-4xl font-bold mb-4">{t('legal.terms.title')}</h1>

        <p className="mb-8 text-muted-foreground">
          {t('legal.terms.questions_intro')}{" "}
          <Button
            variant="link"
            className="p-0 h-auto text-primary font-semibold"
            onClick={() => navigate("/contact-us")}
          >
            {t('legal.terms.contact_link')}
          </Button>
        </p>

        <div className="space-y-8 text-foreground/90">
          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.overview_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.overview_intro')}
            </p>
            <p className="mb-4">
              <strong>{t('legal.privacy.service_provider')}:</strong> gitfit.ai<br />
              <strong>{t('legal.privacy.location')}:</strong>{t('ui.text.united_states')}<br />
              <strong>{t('legal.privacy.contact')}:</strong> <a href="/contact-us" className="text-blue-500 hover:underline">{t('legal.privacy.contact_link')}</a>
            </p>
            <p className="mb-4 font-semibold">
              {t('legal.terms.age_restriction')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.acceptable_use_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.acceptable_use_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.acceptable_use_1')}</li>
              <li>{t('legal.terms.acceptable_use_2')}</li>
              <li>{t('legal.terms.acceptable_use_3')}</li>
              <li>{t('legal.terms.acceptable_use_4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.prohibited_title')}</h2>
            <p className="mb-4 font-semibold text-destructive">
              {t('legal.terms.prohibited_warning')}
            </p>
            <p className="mb-4">
              {t('legal.terms.prohibited_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.prohibited_1')}</li>
              <li>{t('legal.terms.prohibited_2')}</li>
              <li>{t('legal.terms.prohibited_3')}</li>
              <li>{t('legal.terms.prohibited_4')}</li>
              <li>{t('legal.terms.prohibited_5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.privacy_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.privacy_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.privacy_1')}</li>
              <li>{t('legal.terms.privacy_2')}</li>
              <li>{t('legal.terms.privacy_3')}</li>
              <li>{t('legal.terms.privacy_4')}</li>
            </ul>
            <p className="mt-4">
              {t('legal.terms.privacy_more_details')}{" "}
              <Button
                variant="link"
                className="p-0 h-auto text-primary"
                onClick={() => navigate("/privacy-policy")}
              >
                {t('legal.terms.privacy_policy_link')}
              </Button>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.payment_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.payment_intro')}
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">{t('legal.terms.web_purchases_title')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.web_purchases_1')}</li>
              <li>{t('legal.terms.web_purchases_2')}</li>
              <li>{t('legal.terms.web_purchases_3')}</li>
              <li>{t('legal.terms.web_purchases_4')}</li>
              <li>{t('legal.terms.web_purchases_5')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">{t('legal.terms.apple_purchases_title')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.apple_purchases_1')}</li>
              <li>{t('legal.terms.apple_purchases_2')}</li>
              <li>{t('legal.terms.apple_purchases_3')}</li>
              <li>{t('legal.terms.apple_purchases_4')}</li>
              <li>{t('legal.terms.apple_purchases_5')}</li>
              <li>{t('legal.terms.apple_purchases_6')}</li>
              <li>{t('legal.terms.apple_purchases_7')}</li>
            </ul>

            <p className="mt-4 text-sm text-muted-foreground">
              {t('legal.terms.payment_disclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.refund_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.refund_intro')}
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">{t('legal.terms.web_purchases_title')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.refund_web_1')}</li>
              <li>{t('legal.terms.refund_web_2')}</li>
              <li>{t('legal.terms.refund_web_3')}</li>
              <li>{t('legal.terms.refund_web_4')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">{t('legal.terms.apple_purchases_title2')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.refund_apple_1')}</li>
              <li>{t('legal.terms.refund_apple_2')} <span className="font-mono text-sm">{t('ui.text.reportaproblem_apple_com')}</span> {t('legal.terms.refund_apple_contact')}</li>
              <li>{t('legal.terms.refund_apple_3')}</li>
              <li>{t('legal.terms.refund_apple_4')}</li>
              <li>{t('legal.terms.refund_apple_5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.lifetime_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.lifetime_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.lifetime_1')}</li>
              <li>{t('legal.terms.lifetime_2')}</li>
              <li>{t('legal.terms.lifetime_3')}</li>
              <li>{t('legal.terms.lifetime_4')}</li>
              <li>{t('legal.terms.lifetime_5')}</li>
            </ul>
            <p className="mt-4 text-sm text-muted-foreground">
              {t('legal.terms.lifetime_disclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.termination_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.termination_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.termination_1')}</li>
              <li>{t('legal.terms.termination_2')}</li>
              <li>{t('legal.terms.termination_3')}</li>
              <li>{t('legal.terms.termination_4')}</li>
            </ul>
            <p className="mt-4">
              {t('legal.terms.termination_immediate')}
            </p>
            <p className="mt-4">
              <strong>{t('legal.terms.termination_delete')}:</strong> {t('legal.terms.termination_delete_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.liability_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.liability_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.terms.liability_1')}</li>
              <li>{t('legal.terms.liability_2')}</li>
              <li>{t('legal.terms.liability_3')}</li>
              <li>{t('legal.terms.liability_4')}</li>
            </ul>
            <p className="mt-4 text-sm text-muted-foreground">
              {t('legal.terms.liability_medical')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.ip_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.ip_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.changes_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.changes_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.governing_law_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.governing_law_desc_1')}
            </p>
            <p className="mb-4">
              {t('legal.terms.governing_law_desc_2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.availability_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.availability_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.terms.contact_title')}</h2>
            <p className="mb-4">
              {t('legal.terms.contact_desc')}
            </p>
          </section>

          <section className="pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              {t('legal.last_updated', { date: new Date().toLocaleDateString() })}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
